import type { CSSProperties, ReactNode } from 'react';

import styles from './MetagameSmallWidget.module.scss';

interface MetagameSmallWidgetProps {
  balanceValue: string;
  widgetImageUrl?: string;
  timer?: ReactNode;
  counterStyle?: CSSProperties;
}

export function MetagameSmallWidget(props: MetagameSmallWidgetProps) {
  const { widgetImageUrl, balanceValue, timer, counterStyle } = props;

  return (
    <div className={styles.container}>
      {widgetImageUrl && <img alt="" className={styles.imgGeneral} src={widgetImageUrl} />}
      <div className={styles.content}>
        <div className={styles.counterContainer} style={counterStyle}>
          <span className={styles.counterText}>{balanceValue}</span>
        </div>
        <div className={styles.timerContainer}>{timer}</div>
      </div>
    </div>
  );
}
